LoadTemplates.$inject = ['$templateCache', '$rootScope'];

function LoadTemplates($templateCache, $rootScope) {
    'use strict';

    var timestamp = Date.now();
    
    $rootScope.sidebarUrl = `template-cache/sidebar.html?v=${timestamp}`;
    $templateCache.put(
        'template-cache/sidebar.html?v=' + timestamp,
        require('../../views/partials/sidebar.html'),
    );
    $templateCache.put(
        'template-cache/footer.html',
        require('../../views/partials/footer.html'),
    );
    $templateCache.put(
        'template-cache/main-content.html',
        require('../../views/partials/main-content.html'),
    );
    $templateCache.put(
        'template-cache/top-navbar.html',
        require('../../views/partials/top-navbar.html'),
    );
    $templateCache.put(
        'template-cache/booking/edit.common.html',
        require('../../views/booking/edit.common.html'),
    );
    $templateCache.put(
        'template-cache/booking/edit.info.html',
        require('../../views/booking/edit.info.html'),
    );
    $templateCache.put(
        'template-cache/booking/edit.delete.html',
        require('../../views/booking/edit.delete.html'),
    );
    $templateCache.put(
        'template-cache/booking/edit.done.html',
        require('../../views/booking/edit.done.html'),
    );
    $templateCache.put(
        'template-cache/booking/edit.advance.html',
        require('../../views/booking/edit.advance.html'),
    );
}

export default LoadTemplates;
